export default {
  loading: false
}



// WEBPACK FOOTER //
// ./src/store/services/state.js